import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { LocalService } from 'src/app/core';

@Component({
  selector: 'app-rebate-coordinator-form',
  templateUrl: './rebate-coordinator-form.component.html',
  styleUrls: ['./rebate-coordinator-form.component.scss']
})
export class RebateCoordinatorFormComponent implements OnInit {
  @Input() externalForm: FormGroup | null = null;
  public form!: FormGroup;
  public emailDomain: string = '';
  public termsAndPolicy = [
    {
      text: "Ensure accurate and efficient payment delivery through Global EasyPay (GEP)."
    },
    {
      text: "Receive the GEP email notification with a unique security PIN to claim the Incentive payment on behalf of the Company."
    },
    {
      text: "Complete GEP payment claim process within 90 days of receipt of initial GEP email notification. Payments will be forfeited if not claimed within 90 days."
    },
    {
      text: "Ensure Payment/Rebate Coordinators contact information is accurate and current"
    }
  ];

  constructor(private formBuilder: FormBuilder) {}

  public ngOnInit(): void {
    this.extractEmailDomain();
    if (this.externalForm != null) {
      this.form = this.externalForm;
    } else {
      this.initializeForm();
    }
  }

  private extractEmailDomain(): void {
    const userProfile = LocalService.get("userProfile");
    if (userProfile != null && userProfile.primaryEmail != null) {
      const match = userProfile.primaryEmail.match(/@(.+)$/);
      this.emailDomain = match ? match[1] : "";
    }
  }

  private initializeForm(): void {
    this.form = this.formBuilder.group({
      primaryContactForm: this.getPrimaryRebateDetails(),
      backupContactForm: this.backupRebateContactDetails(),
    });
  }

  private getPrimaryRebateDetails(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: [
        "",
        [
          Validators.required,
          Validators.email,
          this.emailContainsAtSymbol,
          this.domainValidator(this.emailDomain),
        ],
      ],
    });
  }

  private backupRebateContactDetails(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      backupFirstName: [null],
      backupLastName: [null],
      backupEmail: [
        null,
        [
          this.emailContainsAtSymbol,
          this.domainValidator(this.emailDomain),
        ],
      ],
    });
  }

  private domainValidator(domain: string) {
    return (control: { value: string }) => {
      if (!control.value) {
        return null;
      }
      const email = control.value;
      const test = email && email.endsWith(domain) ? null : { domain: true };
      return test;
    };
  }

  private emailContainsAtSymbol(control: AbstractControl) {
    const email = control.value;
    if (email && email.indexOf("@") === -1) {
      return { invalidEmail: 'Email must contain an "@" symbol' };
    }
    return null;
  }

  public getEmailErrorMessage(controlPath: string): string {
    let control = null;
    if (this.form) {
      control = this.form.get(controlPath);
    }

    if (!control) {
      return '';
    }

    if (control.hasError('required')) {
      return 'Email is required.';
    }
    if (control.hasError('domain')) {
      return `Not a valid email. Only your company email is allowed i.e. @${this.emailDomain}.`;
    }
    if (control.hasError('invalidEmail')) {
      return 'Email must contain an "@" symbol.';
    }
    return '';
  }
}
